import { useCallback } from 'react';

import { useAhoyConfig } from '../../components/context';

import defaultTranslations, { type TranslationKey } from './defaultTranslations';

const useTranslate = () => {
  const { translate: providedTranslate } = useAhoyConfig();

  return useCallback(
    (key: TranslationKey, variables: Record<string, string | number> = {}) => {
      let result: string | null = null;

      if (providedTranslate) {
        result = providedTranslate(key, variables);
      }

      if (result) {
        return result;
      }

      let fallback: string = defaultTranslations[key];
      Object.keys(variables).forEach((key) => {
        fallback = fallback.replaceAll(`{{${key}}}`, String(variables[key]));
      });

      return fallback;
    },
    [providedTranslate],
  );
};

export default useTranslate;
